<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>序号</th>
          <th>名称</th>
          <th>价格</th>                    
          <th>颜色</th>
          <th>品牌</th>
          <th>瑕疵</th>
          <th>备注</th>
          <th>状态</th>
          <th>操作</th>          
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>{{index + 1}}</td>
          <td>{{item.name}}</td>
          <td>{{item.price}}</td>
          <td>{{getText(item.color)}}</td>
          <td>{{getText(item.brand)}}</td>
          <td>{{getFlawRecordView(item.flawRecords)}}</td>
          <td>{{item.mark}}</td>
          <td>
            <button class="btn btn-info">{{item.state | status}}</button>
          </td>
          <td v-if="mode==='saved' || mode === 'view'">
            <button v-if="!item.hasPay" class="btn btn-success" @click="payClothe(item)">付款</button>
          </td>
          <td v-if="mode==='editing'">
            <btn size="sm" type="danger" @click="onDeleteClick(item)">删除</btn>
            <btn size="sm" type="primary" @click="onEditClick(item)">修改</btn>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ClotheStatus from '@/js/ClotheStatus'

export default {
  props: ['items', 'mode'],
  filters: {
    status: function(val) {
      return ClotheStatus[val]
    }
  },
  methods: {
    onDeleteClick(item) {
      this.$emit('onDeleteClick', item)
    },
    onEditClick(item) {
      this.$emit('onEditClick', item)
    },
    getFlawRecordView(item) {
      if (!item) {
        return []
      }
      return item.map(function(val, index, arr) {
        return val.text
      })
    },
    getText(item) {
      if (item === null) {
        return ''
      }
      return typeof item === 'object' ? item.text : item
    },
    payClothe(item) {
      this.$router.push(`/pay/clothe/${item.id}`)
    },
    doPayClothe(item) {

    }
  }
}
</script>

<style>
td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/list/TicketClothes.vue